module.exports = __webpack_public_path__ + "static/media/GooglePlay.9c6e4f77.svg";